import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footerCard: {
    justifyContent: "flex-end",
    padding: 15,
    paddingLeft: 5,
  },
  likedContainer: {
    display: "flex",
    alignItems: "center",
  },
  skuButton: {
    backgroundColor: "#ebeeff",
    color: "#414dd4",
    border: "none",
    paddingLeft: 8,
    paddingRight: 8,
    "&:hover": {
      backgroundColor: "#ebeeff",
      color: "#414dd4",
      border: "none",
      boxShadow: "0 0 0 3px #bfc4ff",
    },
    "&:focus": {
      backgroundColor: "#ebeeff",
      color: "#414dd4",
      border: "none",
      boxShadow: "0 0 0 3px #bfc4ff",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  fade: {
    outline: 0,
    width: "65%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  scrubberImg: {
    marginTop: "-1%",
  },
}));

function Eventcard({
  id,
  sku,
  name,
  description,
  image,
  type,
  personalizable,
}) {
  const classes = useStyles();
  // const [liked, setLiked] = useState(false);
  // const [likedCounter, setLikedCounter] = useState(20);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const baseScrubberBarImage =
    "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/images/scrubber-bar-";

  return (
    <>
      <Grid item xs={12} sm={6} md={4}>
        <Card className={classes.card}>
          <CardActionArea onClick={handleOpen}>
            <CardMedia className={classes.cardMedia} alt={name} image={image} />
            <CardContent className={classes.cardContent}>
              <Typography gutterBottom variant="subtitle1" paragraph>
                {name}
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions className={classes.footerCard}>
            {/* <div className={classes.likedContainer}>
              <IconButton aria-label="add to favorites">
                {liked ? (
                  <FavoriteIcon
                  onClick={(e) => {
                    setLiked(false);
                    setLikedCounter(likedCounter - 1);
                  }}
                  />
                ) : (
                  <FavoriteBorderIcon
                  onClick={(e) => {
                    setLiked(true);
                    setLikedCounter(likedCounter + 1);
                  }}
                  />
                )}
              </IconButton>
              <Typography
                variant="body2"
                color="textSecondary"
                component="h6"
                style={{ marginLeft: 0 }}
              >
                {likedCounter}
              </Typography>
            </div> */}
            <Button
              className={classes.skuButton}
              href={`#/${sku.toLowerCase()}`}
              size="small"
            >
              {sku}
              {personalizable ? <sup>*</sup> : ""}
            </Button>
          </CardActions>
        </Card>
      </Grid>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open} className={classes.fade}>
          <div className={classes.paper}>
            <CardMedia
              component="img"
              alt={name}
              image={image}
              title={name}
              className={classes.modalImg}
            />
            <CardMedia
              className={classes.scrubberImg}
              component="img"
              image={baseScrubberBarImage + type + ".png"}
            />
          </div>
        </Fade>
      </Modal>
    </>
  );
}

export default Eventcard;
